import { RoleModel } from './role.model';

export interface UserModel {
   id: string;
   userName: string;
   firstName: string;
   lastName: string;
   fullName: string;
   initials: string;
   isActive: boolean;
   features: string[];
   roles: RoleModel[];
}
